import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';
import {ERROR} from '../../../constants/LabelConstants';
import {FieldApplicantSummary, PersonalApplicantSummaryDTO} from '../../../types/mx/creditoReal/epics';
import {PersonalDataStepViewFieldErrorState} from '../../../types/mx/creditoReal/reducers';

const personalDataStepView = (state = defaultState.creditoReal.ui.personalDataStepView, action) => {
    switch (action.type) {
        case WizardMXActions.APPLICANT_HAS_ANOTHER_APPLICATION_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    docNumberFieldError: ERROR.APPLICANT_HAS_ANOTHER_APPLICATION_ERROR,
                }
            };
        case WizardActions.CHANGE_FIRST_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    firstNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_SECOND_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    secondNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_LAST_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    lastNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_SECOND_LAST_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    secondLastNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_DOC_NUMBER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    docNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_BIRTH_DATE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    birthDateFieldError: action.error
                }
            };
        case WizardActions.CHANGE_CELL_PHONE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    cellPhoneFieldError: action.error
                }
            };
        case WizardActions.CHANGE_GENDER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    genderFieldError: action.error
                }
            };
        case WizardActions.CHANGE_CIVIL_STATUS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    civilStatusFieldError: action.error
                }
            };
        case WizardActions.CHANGE_STUDIES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    studiesLevelFieldError: action.error
                }
            };
        case WizardActions.CHANGE_ECONOMIC_DEPENDENTS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    economicDependentsFieldError: action.error
                }
            };
        case WizardActions.CHANGE_ALREADY_HAS_VEHICLE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    alreadyHasVehicleFieldError: action.error
                }
            };
        case WizardActions.CHANGE_NATIONALITY_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    nationalityFieldError: action.error,
                }
            };
        case WizardMXActions.SET_PERSONAL_DATA_STATE_ACTION.name:
            const fieldSummary: FieldApplicantSummary<PersonalApplicantSummaryDTO, PersonalDataStepViewFieldErrorState>
                = action.fieldSummary;
            return {
                ...state,
                fieldErrors: fieldSummary.fieldErrors
            };

        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return {
                ...defaultState.creditoReal.ui.personalDataStepView,
                fieldErrors: {
                    ...defaultState.creditoReal.ui.personalDataStepView.fieldErrors,
                    firstNameFieldError: null,
                    lastNameFieldError: null
                }
            };
        case UIActions.CLEAN_STATE_ACTION.name:
            return defaultState.creditoReal.ui.personalDataStepView;
        default:
            return state;
    }

};

export default personalDataStepView;